module.exports = __webpack_public_path__ + "img/手机端商品SKU.4d4042e9.png";